export enum ContactDestiny {
	CONTACT = 'CNTCT',
}
